import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../../../services/auth.service";

@Component({
  selector: 'app-company-user-management-add-user',
  templateUrl: './company-user-management-add-user.component.html',
  styleUrls: ['./company-user-management-add-user.component.css']
})
export class CompanyUserManagementAddUserComponent implements OnInit {

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
    console.log("ran")
  }

}
